import React, { Component } from 'react';
import { Select, Form } from 'antd';

const { Option } = Select;
const FormItem = Form.Item;

class SelectCustom extends Component {
  constructor(props) {
    super(props);
    this.lastFetchId = 0;
  }

  state = {
    data: [],
  };

  componentDidMount() {
    this.getData();
  }

  getData = () => {
    this.props
      .loaddata({
        condition: this.condition || '',
      })
      .then(res => {
        this.setState({
          data: res,
        });
      });
  };

  handleSearch = value => {
    this.condition = value;
    this.getData();
  };

  handleChange = () => {};

  render() {
    const { data } = this.state;
    const {
      form: { getFieldDecorator },
      ItemLayout,
    } = this.props;
    const options = data.map(d => <Option key={d.uuid}>{d.name}</Option>);
    return (
      <FormItem label="客户名称" {...ItemLayout}>
        {getFieldDecorator('customUuid', {
          rules: [{ required: true, message: '请选择客户!' }],
        })(
          <Select
            showSearch
            placeholder={this.props.placeholder}
            style={this.props.style}
            defaultActiveFirstOption={false}
            showArrow={false}
            filterOption={false}
            onSearch={this.handleSearch}
            onChange={this.handleChange}
            notFoundContent={null}
          >
            {options}
          </Select>,
        )}
      </FormItem>
    );
  }
}

export default SelectCustom;



// WEBPACK FOOTER //
// ./src/components/crm/custom/SelectCustom.js